import * as React from "react";
import LogoIcon from 'images/logo_menu.svg';
import textParser from '../../services/textParser';
import { TemperatureUnitContext } from '../layout/layout';

export const TextAnswer = ({ text, index }) => {
    const [units] = React.useContext(TemperatureUnitContext);
    return (
        <p key={index} className="mb-6 leading-7 tracking-wide">
            <img src={LogoIcon} alt="" className="relative inline w-4 mr-4 -top-0.5"></img>{textParser({ text: text, units })}
        </p>
    )
}

export const TextQuestion = ({ text }) => {
    const [units] = React.useContext(TemperatureUnitContext);
    return (
        <h3 className="text-xl sm:text-2xl mt-12 mb-6 font-b tracking-wide">
            {textParser({ text, units })}
        </h3>
    )
}

export const TextWrapper = ({ children }) => {
    return (<div className="w-10/12 xs:w-9/12 sm:w-8/12 md:w-6/12 justify m-auto">
        {children}
    </div>)
}